<style>
th {
  font-weight: bold;
  font-size: 10px;
}
td {
  font-size: 10px;
}
</style>

<template>
  <div>
    <base-header type class="rsgradient pb-3 pb-1 pt-3 pt-md-5"></base-header>

    <b-card>
      <b-card-header header-tag="header" class="p-1" role="tab">Debin Spot</b-card-header>

      <div style="font-size:12px">
        Al aceptar esta transacción SE EXTRAERÁN FONDOS DE SU CUENTA por el monto indicado, los que serán remitidos a quien mandó la orden de extracción.<br />
        Tenga en cuenta que NUNCA es necesario dar una autorización para RECIBIR pagos electrónicos
      </div>

      <div v-if="this.model.debinsLenght == 0" class="text-center">
        <div>No se encontraron registros</div>
        <img src="/img/ic_no_resultado.png" style="width: 200px;" />
      </div>
      <div v-else>
        <div style="width: 100%; overflow-x:auto;">
          <table class="table">
            <thead>
              <tr>
                <th scope="col" class="text-center">
                  <strong>Acciones</strong>
                </th>
                <th scope="col" class="text-center">
                  <strong>Id Transacción</strong>
                </th>
                <th scope="col">
                  <strong>Importe</strong>
                </th>
                <th scope="col">
                  <strong>Estado</strong>
                </th>
                <th scope="col">
                  <strong>Fecha Recepción</strong>
                </th>
                <th scope="col">
                  <strong>Fecha Expiración</strong>
                </th>
                <th scope="col">
                  <strong>Nombre Origen</strong>
                </th>
                <th scope="col">
                  <strong>CUIT Origen</strong>
                </th>
                <th scope="col">
                  <strong>CBU/CVU Origen</strong>
                </th>
                <th scope="col">
                  <strong>Fecha Aceptación/Rechazo</strong>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item in this.model.debins"
                v-bind:key="item.EntityID"
                style="border-bottom: 1px solid #d6d4d4; margin-right: 0; margin-left: 0"
              >
                <td class="text-center align-middle">
                  <div v-if="item.AllowAcceptReject" class="text-center">
                    <button
                      type="button"
                      @click="AcceptOrRejectDebin(item.EntityID, true)"
                      class="btn btn-primary"
                      style="border-bottom:10px;background-color:green"
                    >Aceptar</button>
                    <button
                      type="button"
                      @click="AcceptOrRejectDebin(item.EntityID, false)"
                      class="btn btn-primary"
                      style="border-bottom:10px;background-color:red"
                    >Rechazar</button>
                  </div>
                </td>
                <td class="text-center">{{item.TransactionId}}</td>
                <td class="text-center">{{item.Amount}}</td>
                <td class="text-center">{{item.StatusName}}</td>
                <td class="text-center">{{item.FormattedCreationDatetime}}</td>
                <td class="text-center">{{item.FormattedExpirationDate}}</td>
                <td class="text-center">{{item.NameAccountFrom}}</td>
                <td class="text-center">{{item.IdentificationNumberAccountFrom}}</td>
                <td class="text-center">{{item.CvuAccountFrom}}</td>
                <td class="text-center">{{item.FormattedAcceptedRejectedDate}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <b-card-body></b-card-body>
    </b-card>
  </div>
</template>

<script>
import axiosHelpers from "@/helpers/axiosHelpers";

export default {
  data() {
    return {
      model: {
        debins: [],
        debinsLenght: 0
      }
    };
  },
  methods: {
    GetDebinsForUser() {
      let context = this;

      axiosHelpers.axiosGet("Debin/GetDebinsForUser", {}, context, function(
        response
      ) {
        context.model.debins = response.ResponseVM.Items;
        context.model.debinsLenght = context.model.debins.length;
      });
    },
    AcceptOrRejectDebin(debinId, accept) {
      let context = this;

      axiosHelpers.axiosPost(
        "Debin/AcceptOrRejectDebin",
        { DebinId: debinId, Accept: accept },
        context,
        function(response) {
          if (response.ResponseVM.Success) {
            context.GetDebinsForUser();
          }
        }
      );
    }
  },
  mounted() {
    this.GetDebinsForUser();
  }
};
</script>
